import React from 'react';

export type TextareaSize = 'sm' | 'md' | 'lg';

export interface TextareaProps extends Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'size'
> {
  size?: TextareaSize;
  error?: string;
}

const SIZE: Record<TextareaSize, string> = {
  sm: 'text-xs px-3 py-2',
  md: 'text-sm px-3 py-2',
  lg: 'text-md px-4 py-3',
};

const Textarea: React.FC<TextareaProps> = ({
  size = 'md',
  error,
  className = '',
  id,
  rows = 4,
  ...rest
}) => {
  const errorId = error ? `${id}-error` : undefined;
  const borderColor = error ? 'border-error' : 'border-default';
  return (
    <div className="w-full">
      <textarea
        id={id}
        rows={rows}
        aria-invalid={!!error}
        aria-describedby={errorId}
        className={`w-full bg-input ${borderColor} border rounded-md ${SIZE[size]} text-pt-forest placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-pt-gold focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed resize-y transition-shadow duration-[var(--motion-duration-fast)] ${className}`.trim()}
        {...rest}
      />
      {error && (
        <p id={errorId} className="text-xs text-error mt-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default Textarea;
